<template>
    <div class="table-dot" v-if="isBoolean(data) !== 'other'">
        <template v-if="isBoolean(data)">
            <i class="dot true-dot"></i><i v-if="trueString" class="text">{{trueString}}</i>
        </template>
        <template v-else >
            <i class="dot false-dot"></i><i v-if="falseString" class="text">{{falseString}}</i>
        </template>
    </div>
</template>

<script>
export default {
  name: 'MyTableDot',
  props: {
    data: '', // true and false
    trueString: {
      type: String,
      default: ''
    },
    falseString: {
      type: String,
      default: ''
    },
  },

  methods: {
    /**
         * 判断是否布尔类型
         * @param {ANY} flag 值
         */
    isBoolean(flag) {
      if (typeof flag === 'boolean') {
        return flag;
      } else {
        return 'other';
      }
    }  
  }
};
</script>

<style lang="scss" scoped>
    .table-dot {
        display: flex;
        align-items: center;
        justify-content: center;

        .dot {
            width: 5px;
            height: 5px;
            border-radius: 50%;
        }

        .text {
            margin-left: 5px;
        }

        .false-dot {
            background-color: #BCC4D5;
        }

        .true-dot {
            background-color: #6799FF;
        }
    }
</style>